export default __webpack_public_path__ + "static/times_now_semilight-webfont-73cccd4ddbe8b83803f8c1b6f9e334d5.woff";